import {
  Box,
  Typography,
  Slider,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import { CustomButton } from "../../../../v2/MUI_custom_component";
import { useState } from "react";
import GlassModal from "../../../../v2/MUI_custom_component/Modal/GlassModal";
import { toast } from "react-toastify";
import {
  downloadAction,
  handleDownload,
} from "../../../Common/Download Button/downloadAction";
import { downloadTripVoucherUrl } from "../APIs/urls";
import { useDispatch, useSelector } from "react-redux";
import { DownloadOutlined } from "../../../../components/icons";
import {
  sendOTPAction,
  verifyOTPAction,
} from "../../../Auth/Register/API/Action";
import { encryptPassword } from "../../../../v2/Utils/Encryption/NodeForgeEncryption";
import OTPVerificationComponent from "../../../Common/OTPVerification/OTPVerificationComponent";

export const VoucherCard = ({ voucherData }) => {
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedEntity: selectedCompanyEntity } = useSelector(
    (state) => state.entityReducer,
  );
  const userId = useSelector((state) => state.loginReducer.loginUser?.user_id);
  const isMobile = useMediaQuery("(max-width: 1200px)");
  const dispatch = useDispatch();

  const handleDownloadVoucher = async () => {
    setOpenVerifyModal(true);
    await handleResendOTP({
      mobile_number: encryptPassword(
        voucherData.mobile_no_registered_for_credit,
      ),
      purpose: "VERIFICATION",
      user_id: encryptPassword(String(userId)),
    });
    
  };

  const handleResendOTP = async (payload, resend = false) => {
    const { error, message } = await sendOTPAction(payload);
    if (!error) {
      if (resend !== true) {
        toast.success(message || "OTP sent successfully");
      }
      return { success: true, message };
    } else {
      toast.error(message || "Failed to send OTP");
      return { success: false, message };
    }
  };

  const handleVerifyOTP = async (otpValue) => {
    const payload = {
      mobile_number: encryptPassword(
        voucherData.mobile_no_registered_for_credit,
      ),
      otp: encryptPassword(otpValue),
      purpose: "VERIFICATION",
      user_id: encryptPassword(String(userId)),
    };
    const { data, error, message } = await verifyOTPAction(payload);
    if (!error) {
      dispatch({ type: "SET_VFC_TOKEN", payload: data.vfc_token });
      return { success: true, data, message, vfc_token: data.vfc_token };
    } else {
      return { success: false, message };
    }
  };

  const handleVerifySuccess = () => {
    if (isLoading) return;
    setOpenVerifyModal(false);
    setIsLoading(true);
    const showToast = "Holiday Credit downloaded successfully!";
    const queryParams = new URLSearchParams();
    queryParams.append("company_esi_id", selectedCompanyEntity);
    queryParams.append("credit_id", voucherData?.credit_id);
    handleDownload(
      () => downloadAction(downloadTripVoucherUrl, queryParams, "Holiday_Credit.pdf"),
      setIsLoading,
      showToast,
    );
  };

  return (
    <>
      <Box
        sx={{
          padding: 1,
          borderRadius: 2,
          background:
            "radial-gradient(72.21% 89.9% at 75.56% 10.1%, rgba(255, 165, 37, 0.105) 29.33%, rgba(0, 129, 242, 0.15) 93.27%)",
          display: "flex",
          flexDirection: "column",
          gap: isMobile ? 1 : 2,
        }}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            aspectRatio: "342 / 117",
            borderRadius: 2,
            overflow: "hidden",
          }}>
          <Box
            component="img"
            src={voucherData?.image_url}
            alt="Voucher"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center center",
              display: "block",
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: isMobile ? 1 : 2,
            alignItems: "flex-end",
          }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              minWidth: 0,
            }}>
            <Typography
              variant="body1"
              sx={{
                color: "#666",
              }}>
              {voucherData?.credit_utilisation_info?.display_label}
            </Typography>
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography variant="h2" sx={{ color: "#995A00" }}>
                {voucherData?.credit_utilisation_info?.value}%
              </Typography>
              {voucherData?.credit_utilisation_info?.credit_update_date && (
                <Typography variant="p3" sx={{ color: "#666" }}>
                  {voucherData?.credit_utilisation_info?.credit_update_date}
                </Typography>
              )}
            </Box>
          </Box>
          <CustomButton
            variant="filled"
            color="primary"
            size={isMobile ? "small" : "medium"}
            disabled={
              isLoading || voucherData?.credit_utilisation_info?.value === 100
            }
            label={
              isLoading ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CircularProgress size={20} />
                  <span>Downloading...</span>
                </Box>
              ) : (
                "Holiday Credits"
              )
            }
            leftIcon={!isLoading && DownloadOutlined}
            onClick={handleDownloadVoucher}
          />
        </Box>
        <Slider
          step={10}
          min={0}
          max={100}
          value={voucherData?.credit_utilisation_info?.value || 0}
          sx={{
            height: "8px",
            color: "#FFA525",
            padding: "4px 0 !important", // override all default and touch padding
            m: 0,
            "& .MuiSlider-thumb": {
              backgroundColor: "#fff",
              height: "12px",
              width: "12px",
              transition: "none", // removes thumb animation
              cursor: "none", // removes pointer cursor on thumb
              "&:hover": {
                boxShadow: "none", // removes hover ripple/glow
              },
              "&.Mui-active": {
                boxShadow: "none", // removes active/click ripple
              },
              "&.Mui-focusVisible": {
                boxShadow: "none", // removes focus ring
              },
            },
            "& .MuiSlider-track": {
              transition: "none", // removes track animation
            },
            "& .MuiSlider-rail": { transition: "none" },
          }}
        />
      </Box>
      <GlassModal
        open={openVerifyModal}
        onClose={() => setOpenVerifyModal(false)}
        title="Enter OTP"
        maxWidth="560px"
        maxHeight="30%">
        <OTPVerificationComponent
          mobileNumber={voucherData.mobile_no_registered_for_credit}
          onVerify={handleVerifyOTP}
          onResend={() =>
            handleResendOTP(
              {
                mobile_number: encryptPassword(
                  voucherData.mobile_no_registered_for_credit,
                ),
                purpose: "VERIFICATION",
                user_id: encryptPassword(String(userId)),
              },
              true,
            )
          }
          otpLength={4}
          initialTimer={60}
          showMobileNumber
          onAnimationComplete={handleVerifySuccess}
        />
      </GlassModal>
    </>
  );
};
